import LOGO from "./../../../../images/Logo.svg";
import LOGO_WHITE from "./../../../../images/Logo_white.svg";

export const getLogo = () => ({
  logo: <img src={LOGO} alt="brand" />,
  logoWhite: <img src={LOGO_WHITE} alt="brand" />,
});
